import React from "react";
import { FaYoutube, FaInstagram, FaFacebookF, FaWhatsapp } from "react-icons/fa";
import "./socialLinks.css";

export default function SocialLinks({ product }) {
  if (!product) return null;

  const { youtube_link, instagram_link, facebook_link, whatsapp_link } = product;

  // Filter links that exist and are non-empty
  const links = [
    {
      id: "youtube",
      name: "YouTube",
      url: youtube_link,
      icon: <FaYoutube className="social-icon" />,
      color: "#FF0000",
      bgHover: "rgba(255, 0, 0, 0.1)",
    },
    {
      id: "instagram",
      name: "Instagram",
      url: instagram_link,
      icon: <FaInstagram className="social-icon" />,
      color: "#E1306C",
      bgHover: "rgba(225, 48, 108, 0.1)",
    },
    {
      id: "facebook",
      name: "Facebook",
      url: facebook_link,
      icon: <FaFacebookF className="social-icon" />,
      color: "#1877F2",
      bgHover: "rgba(24, 119, 242, 0.1)",
    },
    {
      id: "whatsapp",
      name: "WhatsApp",
      url: whatsapp_link,
      icon: <FaWhatsapp className="social-icon" />,
      color: "#25D366",
      bgHover: "rgba(37, 211, 102, 0.1)",
    },
  ].filter((item) => item.url && item.url.trim() !== "");

  if (links.length === 0) return null;

  return (
    <div className="social-connect-container my-4 p-4 rounded-3 shadow-sm bg-white border border-success border-opacity-25">
      <h6 className="text-uppercase fw-bold text-success mb-3 tracking-wide d-flex align-items-center">
        <span className="me-2" style={{ width: "12px", height: "12px", borderRadius: "50%", backgroundColor: "#2e7d32", display: "inline-block" }}></span>
        CONNECT WITH US
      </h6>
      <div className="d-flex flex-wrap gap-3 align-items-center">
        {links.map((link) => (
          <a
            key={link.id}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className="social-card-item d-flex align-items-center text-decoration-none px-3 py-2 rounded-pill shadow-xs border transition-all"
            style={{
              "--icon-color": link.color,
              "--hover-bg": link.bgHover,
              backgroundColor: "#f8f9fa",
              color: "#333",
              fontWeight: "500",
              fontSize: "0.95rem"
            }}
          >
            <span className="icon-wrapper me-2 d-flex align-items-center justify-content-center" style={{ color: link.color, fontSize: "1.25rem" }}>
              {link.icon}
            </span>
            <span>{link.name}</span>
          </a>
        ))}
      </div>
    </div>
  );
}
